import merge from 'deepmerge';
import * as helpers from '../../../helpers';
import l10n from '../../../lang/locallang';

export default class Validator {
    constructor(field, submitButton, options = {}) {
        this.field = field;
        this.fieldParent = field.parentElement;
        this.errorTargetField = this.field;
        this.customErrorText = field.getAttribute('data-message-text');
        this.changeEventName = 'change';

        // Dependency injection
        this.submitButton = submitButton;

        this.defaultOptions = {
            defaultErrorText: l10n.entryError,
            classList: {
                defaultFieldError: 'is-error',
                fieldError: '',
                error: 'parsley-errors-list',
            },
        };

        // Options
        this.options = merge(this.defaultOptions, options);

        // Events
        this.$handleFieldChange = this.handleFieldChange.bind(this);

        // state
        this.isErrorExist = false;

        this.init();
    }

    init() {
        this._initChangeEventListener(this.changeEventName);
    }

    destroy() {
        this._removeChangeEventListener(this.changeEventName);
    }

    _initChangeEventListener(changeEventType) {
        this.field.addEventListener(changeEventType, this.$handleFieldChange);
    }

    _removeChangeEventListener(changeEventType) {
        this.field.removeEventListener(changeEventType, this.$handleFieldChange);
    }

    validate() {
        return true;
    }

    get isValid() {
        return this.validate();
    }

    manageClasses() {
        const { defaultFieldError, fieldError } = this.options.classList;

        helpers.addClass(this.field, defaultFieldError);

        if (fieldError) {
            helpers.addClass(this.field, fieldError);
        }
    }

    removeClasses() {
        const { defaultFieldError, fieldError } = this.options.classList;

        helpers.removeClass(this.field, defaultFieldError);

        if (fieldError) {
            helpers.removeClass(this.field, fieldError);
        }
    }
    
    addErrorAttribute() {
        this.field.setAttribute('aria-invalid', 'true');
    }

    removeErrorAttribute() {
        this.field.removeAttribute('aria-invalid', 'true');
    }

    addError() {
        const { error: errorClass } = this.options.classList;
        const { defaultErrorText } = this.options;

        if (!this.isErrorExist && !this.fieldParent.querySelector(`.${errorClass}`)) {
            const error = Validator.createError(this.customErrorText || defaultErrorText);
            helpers.insertAfter(error, this.field);
        }
    }

    removeError() {
        const { error: errorClass } = this.options.classList;

        if (!this.isErrorExist) {
            return;
        }

        const error = this.fieldParent.querySelector(`.${errorClass}`);

        if (error) {
            this.fieldParent.removeChild(error);
        }
    }

    handleFieldChange() {
        if (this.isValid) {
            this.removeError();
            this.removeClasses();
            this.removeErrorAttribute();

            if (this.submitButton) {
                this.submitButton.enable();
            }

            this.isErrorExist = false;
        } else {
            this.addError();
            this.manageClasses();
            this.addErrorAttribute();

            if (this.submitButton) {
                this.submitButton.disable();
            }

            this.isErrorExist = true;
        }
    }

    static createError(text) {
        const message = document.createElement('div');
        
        helpers.addClass(message, 'parsley-errors-list');
        message.innerHTML = `<p>${text}</p>`;

        return message;
    }
}
